// extracted by mini-css-extract-plugin
export default {"errorFallbackContainer":"ErrorFallback_errorFallbackContainer__nFnAq","error":"ErrorFallback_error__O026A"};